import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = () => {
	const isAuthenticated = !!localStorage.getItem("token");
	// console.log(localStorage.getItem("token"));

	return isAuthenticated ? <Outlet /> : <Navigate to="/login" />;
	// return isAuthenticated ? <Outlet /> : <Outlet />;
};

export default ProtectedRoute;
